/**
 * Dashboard tools catalog API — Trending Tools, Editing Tools, etc.
 * Endpoint: GET /api/dashboard-tools
 */
import apiClient from "../client";

/**
 * @param {Object} [options]
 * @param {number[]} [options.categoryIds] - Include only these tool_category ids
 * @param {string[]} [options.slugs] - Include only these slugs (e.g. trending, editing_tools, ai_tools)
 * @param {boolean} [options.dashboardOnly] - Default dashboard tool sections
 * @returns {Promise<{ success: boolean, data: Array, total: number }>}
 */
export const getDashboardTools = async (options = {}) => {
  const params = {};
  const { categoryIds, slugs, dashboardOnly } = options;
  if (Array.isArray(categoryIds) && categoryIds.length) {
    params.category_ids = categoryIds.join(",");
  }
  if (Array.isArray(slugs) && slugs.length) {
    params.slugs = slugs.join(",");
  }
  if (dashboardOnly) {
    params.dashboard_only = true;
  }
  const response = await apiClient.get("/api/dashboard-tools", { params });
  return response.data;
};
